import { useState } from 'react';
import useMapData from './useMapData';
import useMapParams from './useMapParams';

export default function useMapDownload() {
  const [onDownloadClick, setOnDownloadClick] = useState(() => () => {});
  const { mapData, loading } = useMapData();
  const params = useMapParams();
  const mapFilename = params ? `${params.variable}_${params.startDate}_${params.endDate}.png` : '';
  const downloadDisabled = loading || !mapData;

  return {
    onDownloadClick,
    setOnDownloadClick,
    downloadDisabled,
    mapFilename,
  };
}
